import React, { useState, useEffect } from "react";
import Heart from './assets/Heart.png'

import styled from "styled-components";
import "./AboutUs.css";
import CountUp from "react-countup";
import VisibilitySensor from 'react-visibility-sensor';
import imgSrc from "./assets/bus.jpg";
import { motion, useAnimation } from "framer-motion/dist/framer-motion";
import { useInView } from "react-intersection-observer";
import * as Scroll from "react-scroll";
// import {bounceInDown } from 'react-animations'
// import Radium, {StyleRoot} from 'radium';
const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0px;
  position: relative;
  padding: 0 !important;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const CenterTitle = styled.h1`
  text-align: center;
  margin: 80px 0;
  font-size: 50px;
  font-family: dana-bold;
  @media only screen and (max-width: 600px) {
    font-size: 39px;
  }
`;

const CenterTitle2 = styled.div`
  text-align: center;
  font-family: dana-bold;
  font-size: 30px;
  @media only screen and (min-width: 600px) {
    font-size: 30px;
  }
`;

const CenterParagraph = styled.p`
  text-align: center;
  font-size: 20px;
  font-family: dana;
  @media only screen and (max-width: 600px) {
    font-size: 18px;
  }
`;

const CenterDiv = styled.div`
  text-align: center;
  font-family: dana;
  font-size: 20px;
  @media only screen and (min-width: 600px) {
    font-size: 20px;
  }
`;


const backWhite = styled.div`
  background: white !important;
`;
const ebusImage = styled.img`
  width: 100%;
  height: 300px;
`;
const Row = styled.div`
  margin-top: 30px;
`;
const Card = styled.div`
  margin: 50px 0;
  border-radius: 30px;
  
`;
const CardTitle = styled.h3`
  font-size: 35px;
  font-weight:bold;
  text-align: center;
`;
const CardP = styled.p`
  font-size: 20px;
  text-align: center;
  margin-top: 7px;
`;
const Border = styled.div`
  border-bottom: 3px dashed #3dc36d;
`;
const BackRow = styled.div`
  // background-image: linear-gradient(#4de784, #3dc36d);
`;
const greenBGShape = styled.div`
  background: #3dc36d;
`;
const BigCard = styled.div`
  background: white;
  border-radius: 30px;
  margin: 50px 0;
`;
const BigCardContent = styled.div`
  text-align: right;
  font-size: 20px;
  padding: 30px;
  @media only screen and (max-width: 600px) {
    text-align : right;
    padding : 15px;
    font-size: 15px;
  }

`;

const Count = styled.div`
  font-size : 150px;
  text-align-center;
  margin : auto;
  opacity : .5;
  display:flex;
  align-items:center;
  height:100px;
  color:#aaa;
  @media only screen and (max-width: 600px) {
    display : none;
  }
`;

const Count3 = styled.div`
  font-size : 150px;
  text-align-center;
  margin : auto;
  opacity : .5;
  display:flex;
  align-items:center;
  height:100px;
  color:#aaa;
  margin-left:auto !important;
  @media only screen and (max-width: 600px) {
    display : none;
  }
`;

const MediumTitle = styled.h4`
  font-size: 35px;
  font-family: dana;
  text-align: center;
  padding: 10px;
 
`;
const Summary = styled.div
  `text-align-center`
;

const OrangeButton = styled.button`
  line-height:40px;mx-auto;
  border-radius: 30px;
  line-height: 50px;
  background-image: linear-gradient(#F7B61D, #F7941D);
  color: white;
  box-shadow: 0 0 10px #F7941D;
  font-weight: bold;
  outline : none;
  border : none
`;
const bgGreenSpace = styled.div`
  background: blacks;
`;
const Input = styled.input`
  border-radius: 30px;
  outline: none;
  position: relative;
  border: 1px solid #424242;
  padding: 10px 30px;
  text-align: center;
`;

const Bold = styled.p`
    font-weight:bold;
    padding-bottom:0;
    display:inline;
`;

const Link = styled.a`
    outline:none;
    color:white
`;

const Background1 = styled.div`
  display:flex;
  justify-content:around;
  position:absolute;
  z-Index:2;
  top:0px;
  }
  @media only screen and (max-width: 600px) {
    top:0px;
  }
`;
// const styles = {
//   bounceInDown: {
//     animationDuration: '1s',
//     animationName: Radium.keyframes(bounceInDown, 'bounceInDown')
//   }
// }
export default function AboutUsPage() {
  const [viewPortEntered, setViewPortEntered] = useState(false);

  const control = useAnimation();
  const [ref, inView] = useInView();
  const boxVariant = {
    visible: { opacity: 1, scale: 1,originY: -1, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0 , originY: 0}
  };

  const control2 = useAnimation();
  const [ref2, inView2] = useInView();
  const boxVariant2 = {
    visible: { opacity: 1, scale: 1,originY: -1, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0 , originY: 0}
  };

  const control3 = useAnimation();
  const [ref3, inView3] = useInView();
  const boxVariant3 = {
    visible: { opacity: 1, scale: 1,originY: -1, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0 , originY: 0}
  };

  const cardControl = useAnimation();
  const [viewCard, inViewCard] = useInView();
  const cardVariant = {
    visible: { opacity: 1, scale: 1,originX: -1, transition: { duration: 0.3 } },
    hidden: { opacity: 0, scale: 0 , originX: 0}
  };
  
  const cardControl2 = useAnimation();
  const [viewCard2, inViewCard2] = useInView();
  const cardVariant2 = {
    visible: { opacity: 1, scale: 1,originX: 1, transition: { duration: 0.3 } },
    hidden: { opacity: 0, scale: 0}
  };

  const cardControl3 = useAnimation();
  const [viewCard3, inViewCard3] = useInView();
  const cardVariant3 = {
    visible: { opacity: 1, scale: 1,originX: -1, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0 , originX: 0}
  };

  const greenCardcontrol = useAnimation();
  const [greenCard, inViewGreenCard] = useInView();
  const greenCardVariant = {
    visible: { opacity: 1, scale: 1,originY: 1, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0.5 , originY: 0.5}
  };

  const greenCardcontrol2 = useAnimation();
  const [greenCard2, inViewGreenCard2] = useInView();
  const greenCardVariant2 = {
    visible: { opacity: 1, scale: 1,originY: 1, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0.5 , originY: 0.5}
  };

  let scroll = Scroll.animateScroll;

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);
  
  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);

  useEffect(() => {
    if (inView2) {
      control2.start("visible");
    } else {
      control2.start("hidden");
    }
  }, [control2, inView2]);

  useEffect(() => {
    if (inView3) {
      control3.start("visible");
    } else {
      control3.start("hidden");
    }
  }, [control3, inView3]);

  useEffect(() => {
    if (inViewCard) {
      cardControl.start("visible");
    } else {
      cardControl.start("hidden");
    }
  }, [cardControl, inViewCard]);

  useEffect(() => {
    if (inViewCard2) {
      cardControl2.start("visible");
    } else {
      cardControl2.start("hidden");
    }
  }, [cardControl2, inViewCard2]);

  useEffect(() => {
    if (inViewCard3) {
      cardControl3.start("visible");
    } else {
      cardControl3.start("hidden");
    }
  }, [cardControl3, inViewCard3]);

  
  useEffect(() => {
    if (inViewGreenCard) {
      greenCardcontrol.start("visible");
    } else {
      greenCardcontrol.start("hidden");
    }
  }, [greenCardcontrol, inViewGreenCard]);

  
  useEffect(() => {
    if (inViewGreenCard2) {
      greenCardcontrol2.start("visible");
    } else {
      greenCardcontrol2.start("hidden");
    }
  }, [greenCardcontrol2, inViewGreenCard2]);

  

  return (
    <Container>
      <div style={{ position: "relative", backgroundColor: "white" }} className="d-flex align-items-center justify-content-center">
        <Background1 className="row pt-18 pt-md-16 pt-lg-35 d-flex align-items-center justify-content-center">
          <CenterTitle2 style={{ marginTop: '-20px' }} className="col-11 mb-lg-15 mb-md-2">بهبود کیفیت و حمل ونقل با ایباس</CenterTitle2>
          <CenterDiv className="col-md-9 col-11 col-lg-8 mx-aut">
            ایباس یک تیم، متشکل از مهندس‎ین نُخبه ، فن آوران همه فن حریف و ایده
            پردازانی خلاق که با هدف <Bold>بهبود سطح کیفی حمل و نقل جاده ای</Bold> از فروردین
            1401 گِردهم آمده اند ، تا جوری دیگر، به گِردی روزگار نگاه کنند و دور
            چرخ گردون بچرخند.
          </CenterDiv>
        </Background1>
        <img src={imgSrc} className="w-100 col-12 px-0 mx-0 mt-md-0" style={{ width: "100%", marginTop: "235px" }} />
      </div>

      <Row className="mx-auto col-md-8 col-12  row ">
        <motion.div
          className=" col-lg-5 col-12"
          ref={ref}
          variants={boxVariant}
          initial="hidden"
          animate={control}
          >
          <Card>
            <CardTitle>چجوری ؟ </CardTitle>
            <Border></Border>
            <CardP >
              {" "}
              با ارائه راه حل های توسعه حمل و نقل اتوبوسی
            </CardP>
          </Card>
        </motion.div>
        
        <div className="col-lg-2"></div>
        <motion.div
          className=" col-lg-5 col-12"
          ref={ref}
          variants={boxVariant}
          initial="hidden"
          animate={control}
          >
          <Card >
              <CardTitle>به کمک ؟ </CardTitle>
              <Border></Border>
              <CardP>
                {" "}
                فناوری و پلتفرم هوشمند سفر</CardP>
          </Card>
        </motion.div>
        <motion.div
          className=" col-lg-5 col-12"
          ref={ref2}
          variants={boxVariant2}
          initial="hidden"
          animate={control2}
          >
          <Card>
            <CardTitle>با هدف ؟ </CardTitle>
            <Border></Border>
            <CardP>
              {" "}
              کسب درآمد از ارزش خلق شده در بهبود زندگی شما، افزایش کیفیت در سفر
              اتوبوسی ، کاهش هزینه ها و ارائه‎ ی تَجرُبه ای جدید
            </CardP>
          </Card>
        </motion.div>
        <div className="col-lg-2"></div>
        <motion.div
          className=" col-lg-5 col-12"
          ref={ref2}
          variants={boxVariant2}
          initial="hidden"
          animate={control2}
          >
            <Card>
              <CardTitle>از طریق ؟ </CardTitle>
              <Border></Border>
              <CardP>

                با به وجود آوردن یک اکوسیستم فعال اتوبوسی و یک بازیِ بُرد بُرد بُرد
              </CardP>
            </Card>
        </motion.div>
        <motion.div
          className=" col-lg-5 col-12"
          ref={ref3}
          variants={boxVariant3}
          initial="hidden"
          animate={control3}
          >
          <Card
            style={{ background: "white", padding: "40px",maxHeight:"435px" }}
          >
            <CardTitle>برای  </CardTitle>
            <CardP>

              تویی که همیشه در سفری
              <br />
              راهبرِ ایباس که هَمسفرِ توئه
              <br />
              <Bold>  و "سیستم حمل و نقل " درمحیطی بدون مرز </Bold>

            </CardP>
          </Card>
        </motion.div>
        <div className="col-lg-2"></div>
        
        <motion.div
          className=" col-lg-5 col-12"
          ref={ref3}
          variants={boxVariant3}
          initial="hidden"
          animate={control3}
          >
          <Card
            style={{ background: "white", padding: "40px",maxHeight:"435px"  }}
          >
            <CardTitle>به عنوان </CardTitle>
            <CardP>
              {" "}
              به عنوان یک اکوسیستم اتوبوسی با مجموعه ای ناهمگون از انسان ها ، ماشین‎ ها ، ابزارها و نرم افزارها، که تعاملاتشان برپایه‎ی زیرساخت های دیجیتال مفهوم پیدا می کند.
            </CardP>
          </Card>
        </motion.div>
      </Row>
      <MediumTitle style={{ fontWeight: "bold" }}>برای خلق مشترک یک ارزش</MediumTitle>
      <div
        style={{ background: "#3DC36D", height: "300px", position: "relative" }}
      >
        <div style={{ padding: "100px 0" }}>
          <CardTitle style={{ color: "white", fontSize: "30px" }}>
            "بهبود حمل و نقل جاده ای"
          </CardTitle>
          <CenterParagraph style={{ color: "white" }}>
            همراه با رضایت در مسیری جدید قصد داریم با کمترین دغدغه مسافران را به
            مقصد برسانیم
          </CenterParagraph>
        </div>
      </div>

      <BackRow className=" row  bg-ii px-5 px-md-10 px-lg-0 mx-0">
        <div className=" col-lg-8  col-12 mx-auto row mt-10 " >
          <MediumTitle style={{ margin: "0 auto", fontWeight: "bold" }}>ارزش های ایباس</MediumTitle>
        </div>
        <motion.div
          className=" col-lg-9 col-12 mx-auto row "
          ref={viewCard}
          variants={cardVariant}
          initial="hidden"
          animate={cardControl}
          >
          <BigCard className="row">
            <BigCardContent className="col-12 col-md-9 big-card-sm" style={{ fontSize: "20px" }}>
              <h2><Bold style={{ fontSize: "larger" }}>پایداری</Bold></h2>
              <p >
                <strong>سَفـــری سَبز با افزایش طول عُمر اتوبوس</strong>
                <br />
                گسترش سریع و کنترل نشده شهرنشینی در دهه های اخیر به همراه خود چالش
                های بزرگی را به وجودآورده و به طور خاص در مباحث زیست محیطی رشد
                سریع واثرات منفی را شاهد بوده‎ایم. فرآیند تولید اتوبوس، حجم قابل
                توجهی از دی اکسید کربن را در محیط ازخود به جای می‎گذارد که در
                مقایسه‎ی، میزان حجم تولیدی این گاز در جابه‎جایی با اتوبوس ها به
                اهمیت چگونگی افزایش طول عمر آن ها با حداقل ظرفیت پی می بریم.
                <br />
                <br />
                <strong>راه‎کارهای افزایش طول عمرناوگان اتوبوسی:</strong>
                <br />
                برنامه ریزی هوشمندانه و استفاده حداقلی از ظرفیت های ناوگان برای
                جلوگیری از هدررفت انرژی، با ایحاد امکان سفرِبین راهی از نقاط مختلف
                کشور به یکدیگر معاینات فنی به موقع و تعمیرات قطعات برای جلوگیری از
                حوادث و افزایش طول عمر استفاده از قطعات فرسوده‎ اتوبوس در سایر
                صنایع اصول مدیریت ناوگان و رعایت پروتکل های تعیین شده
              </p>
            </BigCardContent>
            <div className="col-2 d-flex align-items-center justify-content-around">
              <Count className="col-1 p-0 m-0 mt-md-10">1</Count>
              <Count className="col-1 pt-md-17 m-0 mt-md-10">*</Count>
            </div>
          </BigCard>
        </motion.div>

        <motion.div
          className=" col-lg-9 col-12 mx-auto row "
          ref={viewCard2}
          variants={cardVariant2}
          initial="hidden"
          animate={cardControl2}
          >
          <BigCard className="row">
            <div className="col-3 d-flex align-items-center justify-content-around">
              <Count className="col-1 p-0 m-0 mt-md-10">2</Count>
              <Count className="col-1 pt-md-17 m-0 mt-md-10">*</Count>
            </div>
            <BigCardContent className="col-12 col-md-9" style={{ marginRight: "auto", fontSize: "20px" }}>
              <h2>
                <Bold style={{ fontSize: "larger" }}>ایمنی و امنیت</Bold>
              </h2>
              <p>
                <strong>مانیتورینگ</strong>
                <br />
                رصد پایش هوشمند تردد و ناوگان و پشتیبانی حین سفر
                <br /><br />
                <strong>اشتراک گذاری مشخصات سفر </strong>
                <br />
                با امکان اشتراک گذاری لحظه ای امنیت، آرامش و امکان
                برنامه ریزی سفررا در اختیار مسافران ، راهبران و خانواده
                آن ها قرار می دهیم. علاوه بر این تیم پشتیبانی ایباس برای
                پاسخگویی در موارد اضطراری هنگام سفر به صورت 24 ساعته در
                کنار شماست.
              </p>
            </BigCardContent>

          </BigCard>
        </motion.div>

        <motion.div
          className=" col-lg-9 col-12 mx-auto row "
          ref={viewCard3}
          variants={cardVariant3}
          initial="hidden"
          animate={cardControl3}
          >
            <BigCard className=" row">
              <BigCardContent className="col-12 col-md-9" style={{ fontSize: "20px" }}>
                <h2><Bold style={{ fontSize: "larger" }}>ارتقا سطح کیفی سفر، با تجربه‎ای جدید</Bold></h2>
                <p>
                  امکان جابه جایی راحت و آسان از هر مبدائی به هر مقصدی
                  بدون در نظر گرفتن درآمد و شرایط زندگی افراد، همه‎
                  نیازمند دسترسی به حمل و نقل مقرون به صرفه می باشند و
                  قیمت گذاری پویا به عنوان اهرمی برای متعادل کردن عرضه و
                  تقاضا، با در نظر گرفتن عوامل و رفتار مشتریان ایرانی برای
                  تجربه‎ای بهتر عمل می کند.
                </p>
              </BigCardContent>
              <div className="col-3 d-flex align-items-center justify-content-around">
                <Count3 className="col-1 p-0 m-0 mt-md-10">3</Count3>
                <Count3 className="col-1 pt-md-17 m-0 mt-md-10">*</Count3>
              </div>
            </BigCard>
        </motion.div>
      </BackRow>
      <Summary className="row d-flex justify-content-around">
        <CenterTitle className="col-12 mb-10">خلاصه...</CenterTitle>
        <CenterParagraph className="col-10 mb-0">
          بدون نیاز به حضور در ترمینال‎های شلوغ بلیطِ خودتون رو از سایت
          زودتر از موعد سفر تهیه کنید

          <div className="mt-10"><Bold>همین الان بلیط ات رو بخر!</Bold></div>
          <br />
        </CenterParagraph>
        <OrangeButton className="col-4 mx-auto mb-15"><Link href="http://ebus.ir/">جستجوی بلیط</Link> </OrangeButton>
      </Summary>
      <motion.div
          className="mt-5"
          ref={greenCard}
          variants={greenCardVariant}
          initial="hidden"
          animate={greenCardcontrol}
          >
        <div
          style={{
            background: "#3DC36D",
            padding: "60px 0",
            position: "relative",
          }}
        >
          <Row className="row">
            <CenterParagraph style={{ color: "white" }} className="col-md-8 col-11 mx-auto">
              امکان خرید بلیط زودهنگام را شاید در خیلی از سایت های فروش بلیط اتوبوس دیده باشید! ولی فرق بزرگــی بین ایباس واون‎ سایت‎ها وجود داره و اون هم خرید بلیط اتوبوس با قیمت گُذاری پویاست. با این سیستم می‎تونید بلیط اتوبوس‎تون رو بر حَسبِ تاریخ و زمان خرید اون با کَم‎ترین قیمت پیشنهادی ، زیر قیمت مُصوَب خریداری کنید.
            </CenterParagraph>
          </Row>
          <Row className="row">
            <div
              className="col-md-8 col-10 mx-auto row"
              style={{
                background: "white",
                padding: "20px",
                borderRadius: "30px",
              }}
            >
              <div className="col-lg-7 col-12 " style={{ fontSize: "20px" }}>
                در رابطه با قیمت گذاری پویا مفصل در اینجا بخونید
              </div>
              <button
                className="col-lg-5 col-12 "
                style={{
                  fontSize: "20px",
                  background: "linear-gradient(#4DE784, #3DC36D)",
                  padding: "10px 0",
                  borderRadius: "30px",
                  color: "white",
                  outline: "none",
                  border: "none   ",
                  margin: '0 auto'
                }}
              >
                <Link href="http://ebus.ir/dynamicPricePage">قیمت گذاری پویا</Link>
              </button>
            </div>
          </Row>
        </div>
      </motion.div>
      <CenterParagraph
        className="col-lg-7 mx-auto "
        style={{ margin: "8rem 0" }}
      >
        امکان <Bold>اشتراک گذاری مسیر سفر</Bold> را برای ایمنی و برنامه ریزی سفر فراهم کردیم.
        امکان سفراتوبوسی <Bold>ارزان و با کیفیت</Bold> را برای شما فراهم کردیم تا مُقایسه
        کُنید وبعد بلیط اتوبوس اینترنتی را از سایت ایباس خریداری کنید.
      </CenterParagraph>
      
      <motion.div
          className="mt-5"
          ref={greenCard2}
          variants={greenCardVariant2}
          initial="hidden"
          animate={greenCardcontrol2}
          >
      <div
        style={{
          background: "#3DC36D",
          padding: "60px 0",
          position: "relative",
        }}
        
      >
        <Row className="row">
          <CenterParagraph style={{ color: "white" }} className="col-md-8 col-11 mx-auto"> یادتون
            باشه بلیط خریداری شده از ایباس پَس گرفته میشه برای خیال راحتِ شما از لغو
            سفرهای احتمالی
          </CenterParagraph>
        </Row>
        <Row className="row">
          <div
            className="col-md-8 col-10 mx-auto row"
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "30px",
            }}
          >
            <div className="col-lg-7 col-12 " style={{ fontSize: "20px" }}>
              در رابطه با استرداد بلیط مفصل در اینجا بخوانید
            </div>
            <button
              className="col-lg-5 col-12 "
              style={{
                fontSize: "20px",
                background: "linear-gradient(#4DE784, #3DC36D)",
                padding: "10px 0",
                borderRadius: "30px",
                color: "white",
                outline: "none",
                border: "none   ",
                margin: '0 auto'
              }}
            >
              استرداد بلیط
            </button>
          </div>
        </Row>
      </div>
      </motion.div>
      <div className="row" style={{ background: "white" }}>
        <Row
          className="col-12 col-md-8 mx-auto row  d-flex align-items-center" style={{ minHeight: "320px" }}
        >
          <div className="col-lg-6">
            <CenterParagraph style={{ textAlign: "right" }}>
              تو روزهای سخت نمی‎خواستیم هزینه سفر زیاد، بارِ اضافی رو دوش شما
              باشه.<Bold> بَر گِرد چَرخ هیجان ایباس با ما بچرخید</Bold> ، که از هیجانِ
              پیشنهادات ویژه سفر با ایباس جا نَمونید ، خُبرنامه‎تون رو برامون
              بزارید تا خَبرتون کنیم.
            </CenterParagraph>
          </div>
          <div className="col-lg-6 m-auto row">
            <h2
              className="col-12"
              style={{ textAlign: "center", position: "relative", fontWeight: "bold", fontSize: "33px" }}
            >
              اطلاع از تخفیف ها
            </h2>
            <Input placeholder="شماره تلفن خود را وارد کنید" className="col-12 col-md-8 mb-3 "
              style={{
                outline: "none",
                border: "1px solid #ccc",
              }} />
            <OrangeButton className="col-12 col-md-4 mb-3">خبرم کن</OrangeButton>
          </div>
        </Row>
      </div>
      <div className="col-lg-8 mx-auto row" style={{ margin: "5rem 0" }}>
        <CenterParagraph className="col-lg-12 mx-auto">
          ایباس برای تحقق این امر با شناخت مشکلاتتون تو همه جوانبِ سفر اتوبوسی،
          سعی کرده راه‎ حل های مناسبی پیدا کنه، و نظرات شما همیشه می تونه تو
          ارائه راه‎کار موثر کمک‎مون کنه، همراه ایباس باشید. پس ازتون می‎خوایم
          تجربه سفرتون با اتوبوس‎های ایباس رو با ما به اشتراک بگذارید.
        </CenterParagraph>
        <textArea
          placeholder="نظرهای خودتون رو بنویسید"
          className="col-lg-12 mx-auto"
          style={{
            outline: "none",
            border: "1px solid #ccc",
            borderRadius: "30px",
            height: "150px",
            padding: "30px",
          }}
        ></textArea>
        <OrangeButton className="col-12 col-md-4 mt-5">ثبت نظر</OrangeButton>
      </div>

      <div style={{ background: "white" }}>
        <Row className="row ">
          <div className="col-lg-8 mx-auto row d-flex justify-content-around" >
            <div className="col-md-4 col-10">
              <CountUp start={viewPortEntered ? null : 0} end={145} >
                {({ countUpRef }) => {
                  return (
                    <VisibilitySensor
                      active={!viewPortEntered}
                      onChange={isVisible => {
                        if (isVisible) {
                          setViewPortEntered(true);
                        }
                      }}
                      delayedCall
                    >
                      <CenterTitle ref={countUpRef} />
                    </VisibilitySensor>
                  );
                }}
              </CountUp>
              <CenterParagraph style={{ marginTop: '-50px' }}>ساعت همسفر شما تو جاده ها بودیم</CenterParagraph>
            </div>
            <div className="col-md-4 col-10">
              <CountUp start={viewPortEntered ? null : 0} end={234} >
                {({ countUpRef }) => {
                  return (
                    <VisibilitySensor
                      active={!viewPortEntered}
                      onChange={isVisible => {
                        if (isVisible) {
                          setViewPortEntered(true);
                        }
                      }}
                      delayedCall
                    >
                      <CenterTitle ref={countUpRef} />
                    </VisibilitySensor>
                  );
                }}
              </CountUp>
              <CenterParagraph style={{ marginTop: '-50px' }}>سفر با شما تجربه کردیم</CenterParagraph>
            </div>
            <div className="col-md-4 col-10">
              <CountUp start={viewPortEntered ? null : 0} end={234} >
                {({ countUpRef }) => {
                  return (
                    <VisibilitySensor
                      active={!viewPortEntered}
                      onChange={isVisible => {
                        if (isVisible) {
                          setViewPortEntered(true);
                        }
                      }}
                      delayedCall
                    >
                      <CenterTitle ref={countUpRef} />
                    </VisibilitySensor>
                  );
                }}
              </CountUp>
              <CenterParagraph style={{ marginTop: '-50px' }}>نفر ایباس را برای سفر جاده ای انتخاب کرده اند</CenterParagraph>
            </div>
          </div>
        </Row>
      </div>
      <Row className="col-lg-8 col-12 mx-auto row d-flex justify-content-around">
        <CenterTitle className="col-12 mx-auto mb-0">به داشتن شما افتخار میکنیم</CenterTitle>
        <CenterParagraph className="col-10 mx-auto">#همیشه به سفر</CenterParagraph>
        <img src={Heart} className="col-md-3 col-4 mx-auto" />
      </Row>
    </Container>
  );
}
